<nb-card>

  <nb-card-body [formGroup]="DayForm">

    <div class="form-group row">
      <div i18n="@@DayName" class="col-sm-2 label col-form-label">
        Day Name
      </div>

      <div class="col-sm-4">
        <input formControlName="DayName" nbInput type="text" fullWidth shape="semi-round"
          i18n-placeholder="@@DayName" placeholder="Day Name" (change)="NameChange($event)" [attr.disabled]="true">
      </div>

      <div>
        <app-meal-metrics-graph class="Metrics" [MealCals]="MealCals" [MealProtein]="MealProtein" [MealCarbs]="MealCarbs" [MealFats]="MealFats" [GraphInBack]="true"></app-meal-metrics-graph>
      </div>

    </div>

    <div class="form-group row">
      <div class="col-sm-12">

        <div *ngFor="let meal of Day.meals; let i = index">
          <app-meal-report-presentation [PlanMeal]="meal" [Index]="i"></app-meal-report-presentation>
          <div style="height:10px"></div>
        </div>

      </div>
    </div>
  </nb-card-body>
</nb-card>
